import { render, staticRenderFns } from "./VennSettings.vue?vue&type=template&id=59738846&scoped=true"
import script from "./VennSettings.vue?vue&type=script&lang=js"
export * from "./VennSettings.vue?vue&type=script&lang=js"
import style0 from "./VennSettings.vue?vue&type=style&index=0&id=59738846&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59738846",
  null
  
)

export default component.exports